var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SectionPageHero',{attrs:{"variant":"news","title-lead":_vm.$i18n.locale === 'en' ? 'News' : 'ข่าวสาร',"title-highlight":_vm.$i18n.locale === 'en' ? '& Events' : '& กิจกรรม'}})}
var staticRenderFns = []

export { render, staticRenderFns }